"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cookie = void 0;
var React = require("react");
var react_1 = require("react");
var Cookie_style_1 = require("./Cookie.style");
var Button_1 = require("../../Button");
exports.Cookie = function (props) {
    var _a = react_1.useState(true), isVisible = _a[0], setVisible = _a[1];
    react_1.useEffect(function () {
        if (typeof Storage !== 'undefined') {
            var cookie = localStorage.getItem('swsmCookiePolicy');
            if (cookie) {
                setVisible(false);
            }
        }
        else {
            setVisible(false);
        }
    }, []);
    var handleCookie = function () {
        setVisible(false);
        localStorage.setItem('swsmCookiePolicy', isVisible ? 'true' : '');
    };
    var renderCookie = function () { return (React.createElement(Cookie_style_1.default.Wrap, { isVisible: isVisible, "data-test": "cookie-info" },
        React.createElement(Cookie_style_1.default.TextWrap, null,
            React.createElement(Cookie_style_1.default.Text, null, props.children),
            React.createElement(Cookie_style_1.default.CtaWrap, null,
                React.createElement(Button_1.default, { "aria-label": "Close button", "data-test": "cookie-info-close", onClick: function () {
                        handleCookie();
                    }, style: {
                        borderRadius: '10px',
                        height: '30px',
                        padding: '8px 20px',
                    } }, "CLOSE"))))); };
    return isVisible ? renderCookie() : null;
};
exports.default = exports.Cookie;
//# sourceMappingURL=Cookie.js.map